import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Wishlist/WishlistMenuButton/wishlistMenuButton.container"
    ).then((module) => ({
        default: module.WishlistMenuButtonContainer
    }))
);
